import React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
} from 'react-hook-form';

interface HiddenInputWithControllerProperties<
  T extends FieldValues = FieldValues,
> {
  control: Control<T>;
  name: Path<T>;
  registeredValue?: PathValue<T, Path<T>>;
}

const HiddenInputWithController = <T extends FieldValues = FieldValues>({
  control,
  name,
  registeredValue,
}: HiddenInputWithControllerProperties<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={registeredValue}
    render={({
      field: { value, ref },
    }) => (
      <input name={name} type="hidden" value={value} ref={ref} />
    )}
  />
  );

export default HiddenInputWithController;
